import request from '@/utils/http.js';
import qs from 'qs';

//策略广场数据(商城热门模拟交易)
export function getMockByHcInfo(options) {
  return request({
    url: `${window.config.api_v1}/transaction/getMockByHcInfo`,
    method: 'GET',
    params: options
  });
}

// 设置公开模拟交易 updatePublicOpen
export function updatePublicOpen(options) {
  return request({
    url: `${window.config.api_v1}/transaction/updatePublicOpen`,
    method: 'GET',
    params: options
  });
}